// 个单批改模块公共混入 mixin
import correctHeader from '@/views/correct/components/header'; // 头部产品名称及保单期限组件
import policyHolder from '@/views/correct/components/policyHolder'; // 投保人组件
import insured from '@/views/correct/components/insured'; // 被保人组件（PC）
import insuredMobile from '@/views/correct/components/insuredMobile'; // 被保人组（移动端）
import plan from '@/views/correct/components/plan'; // 计划信息组件
import additional from '@/views/correct/components/additional'; // 附加信息组件
import correctFooter from '@/views/correct/components/footer'; // 底部按钮及其他组件
import commonOptions from '../common/options'; // 公共数据源
import commonMethods from '../common/methods'; // 公共方法
import api from '../api/index';
import moment from 'moment';
export const commonMixin = {
  components: {
    correctHeader, // 头部产品名称及保单期限组件
    policyHolder, // 投保人组件
    insured, // 被保人组件（PC）
    insuredMobile, // 被保人组件（移动端）
    plan, // 计划信息组件
    additional, // 附加信息组件
    correctFooter // 底部按钮及其他组件
  },
  provide: function() {
    return {
      isMobile: this.isMobile,
      getDisabledAll: () => this.disabledAll
    };
  },
  data() {
    // 是否移动端
    const isMobile = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent);
    return {
      type: 2, // 操作类型（1：新增；2：修改）
      isMobile, // 是否移动端
      disabledAll: false, // 禁止输入
      policyId: '', // 保单id
      productCode: '', // 产品code
      originPolicyForm: {}, // 原始保单数据
      // 保单信息
      policyForm: {
        policy: {
          productName: '', // 产品名称
          effectiveDate: moment(), // 保单开始日期
          expireDate: moment() // 保单结束日期
        }, // 保单数据
        batchHolder: {
          policyNo: '', // 保单号
          totalPremium: '', // 保费
          name: '', // 投保人姓名
          address: '', // 投保人联系地址
          idType: '', // 投保人证件类型
          idNumber: '', // 投保人证件号码
          telephone: '', // 投保人手机号
          contactsphone: '', // 联系人手机
          email: '' // 投保人邮箱
        }, // 投保人数据
        batchInsureList: [], // 被保人数据
        plan: {
          productName: '' // 产品名称
        }, // 计划数据
        totalPremium: undefined, // 总保费
        updateNum: 0, // 修改人数
        chgTotalPremium: 0, // 保费变化金额
        filelist: [], // 资料列表
        remark: '', // 备注
        changeContent: '' // 批改记录
      },
      // 产品计划配置项数据
      planCfg: {
        isShow: false
      },
      // 保单表单规则对象
      policyRules: {
        'batchHolder.name': [{ required: true }],
        'batchHolder.address': [{ required: true }],
        'batchHolder.idType': [{ required: true }],
        'batchHolder.idNumber': [{ required: true }],
        'batchHolder.telephone': [{ required: true, message: '请输入正确的手机号', trigger: 'blur' }],
        'batchHolder.contactsphone': [{ required: true, message: '请输入正确的联系人手机号', trigger: 'blur' }],
        'batchHolder.email': [{ required: true, message: '请输入正确的联系邮箱', trigger: 'blur', pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ }]
      },
      // 保单正在批改中弹窗显示标识
      showTips: false
    };
  },
  watch: {
    // 监听被保人操作类型
    type: function(val) {
      // 如果是新增被保人，则不可修改公共计划信息
      if (this.planCfg.fieldList) {
        this.planCfg.fieldList.forEach(item => {
          item.writeable = val !== 1;
        });
      }
    }
  },
  created() {
    // 解构url参数
    const { policyId, p, operator } = this.$route.query;
    this.policyId = policyId;
    this.productCode = p;
    this.operator = operator;
    // 接口获取保单数据
    this.getPolicyData();
  },
  methods: {
    // 批单生效日选择限制
    batchDateDisDate(current) {
      return current && current < moment(this.policyForm.policy.effectiveDate);
    },
    // 证件有效起期选择限制
    idExpiryStartDisDate(current) {
      return current && current > moment();
    },
    // 证件有效止期选择限制
    idExpiryEndDisDate(current) {
      return current && current < moment();
    },
    // 出生日期选择限制
    birthdateDisDate(current) {
      // 新增子女只能选择一周岁以内
      const relationship = this.$refs.insured.$refs.editInsured.editInsuredForm.relationship;
      // 有上年保单号则去除年龄限制
      const zbLastPolicyNo = this.$refs.insured.$refs.editInsured.editInsuredForm.batchInsuredExt.zbLastPolicyNo;
      if (this.type === 1 && relationship === '3' && !zbLastPolicyNo) {
        return current < moment().subtract(1, 'years') || (current && current > moment());
      }
      return current && current > moment();
    },
    // 新增被保人（移动端）
    addInsuredMobile(type) {
      const addInsuredData = this.$lodash.cloneDeep(this.insuredCfg.addInitData);
      this.policyForm.batchInsureList.push(addInsuredData);
      this.type = type;
      this.disabledAll = type === 1;
    },
    // 删除新增的被保人（移动端）
    delInsuredMobile(index, type) {
      this.policyForm.batchInsureList.splice(index, 1);
      this.type = type;
      this.disabledAll = type === 1;
    },
    // 设置属性
    setItemsProperty(obj, type) {
      debugger
      const pathName = type !== 'edit' ? 'addItems' : 'editItems';
      for (let key in obj) {
        // 多个字段分割
        let keys = key.split(',');
        // 遍历多个字段
        keys.forEach(k => {
          // 根据key找出索引
          const index = this.insuredCfg[pathName][0].items.findIndex(item => {
            return item.key === k;
          });
          // 如果存在索引
          if (index > -1) {
            // 修改对应的字段配置
            const propertyObj = obj[key];
            for (let k1 in propertyObj) {
              this.insuredCfg[pathName][0].items[index][k1] = propertyObj[k1];
            }
          }
        });
      }
    },
    // 设置新增被保人弹窗Form字段的值
    setInsuredVal(obj, index) {
      // 如果当前编辑人员是主被保人，则主被保人名称跟随被保人名称
      const currentData = this.isMobile ? this.policyForm.batchInsureList[index] : this.$refs.insured.$refs.editInsured.editInsuredForm;
      for (let key in obj) {
        // 判断key是否有多层
        const keys = key.split('.');
        if (keys.length > 1) {
          currentData[keys[0]][keys[1]] = obj[key];
        } else {
          currentData[keys[0]] = obj[key];
        }
      }
    },
    // 根据国籍等类型获取证件类型码表
    getIdTypeOps(type) {
      // 默认全部码表
      let ops = commonOptions.idTypeOps;
      // 国籍为中国大陆的证件码表
      if (type === '1') {
        ops = commonOptions.insuredIdType1Ops;
      } else if (type === '2') {
        // 国籍为非中国大陆的证件码表
        ops = commonOptions.insuredIdType2Ops;
      } else if (type === '3') {
        // 全球性计划的证件码表（非子女）
        ops = commonOptions.passportOps;
      } else if (type === '4') {
        // 全球性计划的证件码表（子女）
        ops = commonOptions.globalOps;
      }
      return ops;
    },
    // 首保日期禁选 生效日期之前
    maritalCodeDisDate(current) {
      const effectiveDate = this.policyForm.policy.effectiveDate;
      return (current && current > moment(effectiveDate))
    },
    // 转保保单号失焦事件
    zbLastPolicyNoBlur(value) {
      const isHide = !value;
      this.setItemsProperty({
        "batchInsuredExt.maritalCode": { isHide }
      });

    },
    // FirstName、LastName失焦事件
    enNameBlur(value, type, index) {
      // 当前操作的被保人数据
      const currentData = this.isMobile ? this.policyForm.batchInsureList[index] : this.$refs.insured.$refs.editInsured.editInsuredForm;
      const firstName = currentData.batchInsuredExt.firstNameEn;
      const lastName = currentData.batchInsuredExt.lastNameEn;
      if (firstName && lastName) {
        const nameEn = `${lastName} ${firstName}`;
        currentData.name = nameEn;
        // 如果当前被保人是主被，则一同修改主被保人名称字段
        const isMain = currentData.batchInsuredExt.isMain === 'Y';
        if (isMain) {
          currentData.batchInsuredExt.mainName = nameEn;
        }
      }
    },
    // 获取主被保人姓名
    getMainName() {
      const policyForm = this.$lodash.cloneDeep(this.policyForm);
      let mainNameObj = policyForm.batchInsureList.find(item => item.batchInsuredExt.isMain === 'Y');
      return (mainNameObj && mainNameObj.batchInsuredExt.mainName) || '';
    },
    // 处理被保人数据
    dealInsured(data, flag) {
      let batchInsureList = [];
      // 如果需要处理主被
      if (flag && this.type === 2) {
        // 查询主被保人姓名
        let mainName = this.getMainName();
        // 如果主被保人姓名存在
        if (!mainName) {
          this.$message.error('请选择“是否主被保人”！');
          return false;
        }
        batchInsureList = this.handleInsuredData(mainName);
      } else {
        // 否则
        batchInsureList = data.filter(item => {
          return item.correctType === '修改' || item.correctType === '新增';
        });
      }
      // 处理日期格式
      batchInsureList.forEach(item => {
        item.batchDate = item.batchDate ? moment(item.batchDate).format('YYYY-MM-DD') : item.batchDate;
        item.birthDate = item.birthDate ? moment(item.birthDate).format('YYYY-MM-DD') : item.birthDate;
      });
      return batchInsureList;
    },
    // 提交参数处理
    dealParams() {
      const policyForm = this.$lodash.cloneDeep(this.policyForm);
      const batchInsureList = this.dealInsured(policyForm.batchInsureList);
      const params = {
        policyId: this.policyId,
        batchHolder: policyForm.batchHolder,
        batchInsureList,
        filelist: policyForm.filelist,
        remark: policyForm.remark,
        changeContent: policyForm.changeContent,
        updateNum: policyForm.updateNum
      };
      return params;
    },
    // 公共计划信息变更
    changeCommonPlan() {
      if (!this.isMobile) {
        this.$refs.insured.type = 2;
        this.$refs.insured.saveType = 2;
      }
      this.policyForm.batchInsureList.forEach((item, i) => {
        item.correctType = '修改';
        this.$set(this.policyForm.batchInsureList, i, item);
      });
      this.calPremium();
    },
    // 被保人信息保存
    insuredSave(type, data, index) {
      // 操作类型（1：新增；2：修改）
      this.type = type;
      // 如果是新增被保人信息保存
      if (type === 1 && index < 0) {
        // 调用新增保存方法
        this.addInsuredSave(data);
      } else {
        // 调用各产品私有修改保存方法
        this.editInsuredSave(index);
        // 如果是修改被保人信息保存，则调用计算保费方法
        this.calPremium();
      }
    },
    // 新增被保人信息保存方法
    addInsuredSave(data) {
      // 如果是新增保存
      data.batchInsuredExt = data.batchInsuredExt || {};
      // 证件有效起期
      data.batchInsuredExt.idExpiryStart = data.batchInsuredExt.idExpiryStart ? moment(data.batchInsuredExt.idExpiryStart).format('YYYY-MM-DD') : '';
      // 证件有效止期
      data.batchInsuredExt.idExpiryEnd = data.batchInsuredExt.idExpiryEnd ? moment(data.batchInsuredExt.idExpiryEnd).format('YYYY-MM-DD') : '';
      // 被保人保费
      data.premium = '';
      this.policyForm.batchInsureList.push(data);
      this.calPremium();
    },
    // 删除新增的被保人
    delAddInsured(index) {
      // 删除当前新增的被保人数据
      this.policyForm.batchInsureList.splice(index, 1);
      const addInsuredLIndex = this.policyForm.batchInsureList.findIndex(item => {
        return item.correctType === '新增';
      });
      // 如果没有新增的被保人数据，则重置类型
      if (addInsuredLIndex < 0) {
        this.type = 0;
        this.$refs.insured.type = 0;
        this.$refs.insured.saveType = 0;
      }
      // 重新计算保费
      this.calPremium();
    },
    // 新增被保人表单控件change事件
    addInsuredChg(value, type, index) {
      const key = type.includes('.') ? type.split('.')[1] : type;
      const fn = `${key}Change`;
      this[fn] && this[fn](value, index, 'add');
      // 如果是移动端，则修改后立即调用保费计算方法
      if (this.isMobile) {
        this.$set(this.policyForm.batchInsureList[index], 'correctType', '新增');
        // 保费计算
        this.calPremium();
      }
    },
    // 被保人组件数据change方法（通用）
    changeInsured(value, type, index) {
      // 被保人组件数据change方法（各产品私有）
      const isError = this.privateChangeInsured && this.privateChangeInsured(value, type, index);
      // 如果修改字段有误，则return
      if (isError) {
        return;
      }
      // 如果是移动端，则修改后立即调用保费计算方法
      if (this.isMobile) {
        const correctType = this.type === 1 ? '新增' : '修改';
        this.$set(this.policyForm.batchInsureList[index], 'correctType', correctType);
        // 保费计算
        this.calPremium();
      }
    },
    // 修改被保人信息保存方法
    editInsuredSave(index) {
      // 当前操作的被保人数据
      const currentData = this.isMobile ? this.policyForm.batchInsureList[index] : this.$refs.insured.$refs.editInsured.editInsuredForm;
      // 是主被保人的数据索引
      let mainIndex = -1;
      // 如果当前修改的人员为主被保人
      if (currentData.batchInsuredExt.isMain === 'Y') {
        mainIndex = index;
      } else {
        mainIndex = this.policyForm.batchInsureList.findIndex(item => {
          return item.batchInsuredExt.isMain === 'Y';
        });
      }
      // 主被保人姓名
      const mainName = mainIndex > -1 ? this.policyForm.batchInsureList[mainIndex].name : '';
      this.policyForm.batchInsureList.forEach((item, index) => {
        if (index !== mainIndex) {
          item.batchInsuredExt.isMain = 'N';
        }
        item.batchInsuredExt.mainName = mainName;
      });
    },
    // 与被保人关系change事件
    relationshipChange(val, index) {
      // 如果选择为配偶
      if (val === '2') {
        const isSpouseIdx = this.policyForm.batchInsureList.findIndex(item => item.relationship === '2');
        if (isSpouseIdx > -1) {
          this.$message.error('已存在被保人为配偶');
          if (this.isMobile) {
            this.policyForm.batchInsureList[index].relationship = '';
          } else {
            this.$refs.insured.$refs.editInsured.editInsuredForm.relationship = '';
          }
        }
      }
    },
    // 证件号码change事件
    idNumberChange(value, index) {
      if (!value) {
        return false;
      }
      let idType = this.isMobile ? this.policyForm.batchInsureList[index].idType : this.$refs.insured.$refs.editInsured.editInsuredForm.idType;
      const flag = commonMethods.checkIdNumber(value, idType);
      // 如果证件类型是 1：身份证 && 身份证号码正确
      if (flag && idType == '1') {
        const { birthDate, gender } = commonMethods.calcBGByIdCardNumber(value);
        if (this.isMobile) {
          this.policyForm.batchInsureList[index].birthDate = birthDate;
          this.policyForm.batchInsureList[index].gender = gender;
        } else {
          this.$refs.insured.$refs.editInsured.editInsuredForm.birthDate = birthDate;
          this.$refs.insured.$refs.editInsured.editInsuredForm.gender = gender;
        }
      }
      return flag;
    },
    // 是否主被保人change事件
    isMainChange(value, index) {
      // 主被保人姓名
      const currentData = this.isMobile ? this.policyForm.batchInsureList[index] : this.$refs.insured.$refs.editInsured.editInsuredForm;
      let mainName = currentData.name || '';
      // 如果选择是
      if (value === 'Y') {
        // 如果是移动端，直接修改被保人数据
        if (this.isMobile) {
          this.policyForm.batchInsureList[index].batchInsuredExt.mainName = mainName;
          this.policyForm.batchInsureList.forEach((item, i) => {
            // 修改其他被保人数据
            if (i !== index) {
              item.batchInsuredExt.isMain = 'N';
              item.batchInsuredExt.mainName = '';
            }
          });
        } else {
          this.$refs.insured.$refs.editInsured.editInsuredForm.batchInsuredExt.mainName = mainName;
        }
      } else {
        // 如果选择否
        // 是主被保人的数据索引
        const mainIndex = this.policyForm.batchInsureList.findIndex((item, i) => {
          return i !== index && item.batchInsuredExt.isMain === 'Y';
        });
        // 主被保人姓名
        mainName = mainIndex > -1 ? this.policyForm.batchInsureList[mainIndex].name : '';
        // 如果是移动端，直接修改被保人数据
        if (this.isMobile) {
          this.policyForm.batchInsureList.forEach((item, i) => {
            item.batchInsuredExt.mainName = mainName;
            if (i !== mainIndex) {
              item.batchInsuredExt.isMain = value;
            }
          });
        } else {
          this.$refs.insured.$refs.editInsured.editInsuredForm.batchInsuredExt.mainName = mainName;
        }
      }
    },
    // 被保人姓名change事件
    nameChange(value, index) {
      // 如果当前编辑人员是主被保人，则主被保人名称跟随被保人名称
      const currentData = this.isMobile ? this.policyForm.batchInsureList[index] : this.$refs.insured.$refs.editInsured.editInsuredForm;
      const isMain = currentData.batchInsuredExt.isMain;
      currentData.batchInsuredExt.mainName = isMain === 'Y' ? value : undefined;
    },
    // 证件有效期change事件
    invalidateChange(value, index) {
      // 如果当前编辑人员是主被保人，则主被保人名称跟随被保人名称
      const currentData = this.isMobile ? this.policyForm.batchInsureList[index] : this.$refs.insured.$refs.editInsured.editInsuredForm;
      // 如果是长期有效，则【证件有效止期】默认9999-12-30
      if (value === '1') {
        currentData.batchInsuredExt.idExpiryEnd = moment('9999-12-30');
      } else {
        currentData.batchInsuredExt.idExpiryEnd = '';
      }
    },
    // 处理被保人数据（塞入主被保人姓名）
    handleInsuredData(mainName) {
      const policyForm = this.$lodash.cloneDeep(this.policyForm);
      let batchInsureList = policyForm.batchInsureList.map(item => {
        if (item.batchInsuredExt.isMain !== 'Y') {
          item.batchInsuredExt.mainName = mainName;
          item.batchInsuredExt.isMain = 'N';
        }
        return item;
      });
      return batchInsureList;
    },
    // 保费计算
    calPremium() {
      // 获取每个产品自定义提交数据参数
      const params = this.dealParams();
      // 移动端保费试算判断
      if (this.isMobile) {
        for (let i = 0, len = params.batchInsureList.length; i < len; i++) {
          const item = params.batchInsureList[i];
          if (!item.birthDate) {
            return false;
          }
        }
      }
      api
        .calBatchPremium(params)
        .then(res => {
          // 获取修改后的保费和人数
          const { content } = res.data;
          this.policyForm.chgTotalPremium = content.chgTotalPremium;
          this.policyForm.updateNum = content.updateNum;
          // 如果是修改被保人
          if (this.type === 1) {
            const updateLen = content.batchInsureList.length;
            content.batchInsureList.forEach((item, index) => {
              let i = this.policyForm.batchInsureList.length - updateLen + index;
              this.policyForm.batchInsureList[i].premium = item.newPremium || item.premium;
              this.$set(this.policyForm.batchInsureList, i, this.policyForm.batchInsureList[i]);
            });
          } else {
            content.batchInsureList.forEach(item => {
              const index = this.policyForm.batchInsureList.findIndex(item1 => {
                return item.insureId === item1.insureId;
              });
              this.policyForm.batchInsureList[index].premium = item.newPremium || item.premium;
            });
          }
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    // 比较差异,使用了lodash工具库的transform和isEqual方法
    difference(object, base) {
      const that = this;
      let index;
      function changes(object, base, results = {}) {
        return that.$lodash.transform(
          object,
          function(result, value, key) {
            if (!that.$lodash.isEqual(value, base[key])) {
              if (typeof value === 'object') {
                if (value.insureId) {
                  index = base.findIndex(item => item.insureId === value.insureId);
                }
                return changes(value, base[key], results);
              } else {
                result[`${key}_${index}`] = `${value}`;
              }
            }
          },
          results
        );
      }
      return changes(object, base);
    },
    // 获取需要记录的字段
    getFieldsObj() {
      // 需要记录的字段对象
      let fieldObj = {};
      let fieldsList = [];
      // 如果有被保人配置
      if (this.insuredCfg) {
        this.insuredCfg.editItems.forEach(item => {
          fieldsList = [...fieldsList, ...item.items];
        });
        if (this.planCfg && this.planCfg.fieldList) {
          fieldsList = [...fieldsList, ...this.planCfg.fieldList];
        }
      } else {
        // 根据设备获取被保人基础信息字段
        fieldsList = commonOptions.insuredFields;
      }
      // 合并需要记录的字段
      fieldsList.forEach(item => {
        const key = item.key.includes('.') ? item.key.split('.')[1] : item.key;
        fieldObj[key] = { label: item.label, options: item.dataSource };
      });
      return fieldObj;
    },
    // 记录修改的字段
    changeRecords(currentForm) {
      // 当前操作用户
      const user = this.operator;
      // 如果是新增被保人
      if (this.type === 1) {
        let str = '';
        this.policyForm.batchInsureList.forEach(item => {
          if (item.correctType === '新增') {
            str += `用户【${user}】新增：被保人【${item.name}】`;
          }
        });
        return str;
      }
      // 需要记录的字段对象
      let fieldObj = this.getFieldsObj();
      // 不需要记录的字段
      const notRecordFileds = ['batchDate', 'workUnit', 'invalidate', 'idExpiryStart', 'idExpiryEnd', 'premium', 'correctType', 'isMain', 'mainName'];
      // 获取批改变更的数据
      const changeFieldObj = this.difference(currentForm, this.originPolicyForm);
      debugger
      let str = '';
      // 拼装变更信息
      for (let k in changeFieldObj) {
        const keys = k.split('_');
        const key = keys[0];
        const changIdx = Number(keys[1]) + 1;
        if (notRecordFileds.includes(key) || !fieldObj[key]) {
          continue;
        }
        const label = fieldObj[key].label;
        const val = changeFieldObj[k];
        let valName = val;
        // 获取当前产品所有相关码表
        const optionsList = key === 'idType' ? commonOptions.idTypeOps : fieldObj[key].options;
        // 如果key对应码表存在，则过滤出name
        if (optionsList) {
          valName = optionsList.find(item => item.code === val).name;
        }
        // 拼接信息
        if (label) {
          const item = changIdx || changIdx === 0 ?
            `用户【${user}】修改：被保人【${changIdx}】的【${label}】为【${valName}】；` :
            `用户【${user}】修改：投保人的【${label}】为【${valName}】；`
          str += item;
        }
      }
      return str;
    },
    // 表单数据提交
    submitForm() {
      const params = this.dealParams('save');
      if (!params) {
        return;
      }
      this.toggleLoading(true);
      // 批改记录
      const changeContent = this.changeRecords(params);
      params.changeContent = changeContent;
      api
        .submitBatchData(params)
        .then(res => {
          const { returnCode, content } = res.data;
          // 提交成功，弹出提示框，点击确定关闭页面
          if (returnCode === '00') {
            this.$Modal.success({
              title: content,
              okText: '确定',
              onOk: this.modalOk
            });
          }
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    // 接口获取保单数据
    getPolicyData() {
      this.toggleLoading(true);
      api
        .getBatchInfo(this.policyId)
        .then(res => {
          const { returnCode, content } = res.data;
          // 如果该保单正在批改中
          if (returnCode === '1070') {
            this.showTips = true;
            return;
          }
          // 主被保人数据
          const mainData = content.batchInsureList.find(item => item.batchInsuredExt && item.batchInsuredExt.isMain);
          // 主被保人姓名
          const mainName = mainData ? mainData.name : content.batchInsureList[0].name;
          content.batchInsureList.forEach(item => {
            item.batchPlanParam = item.batchPlanParam ? item.batchPlanParam : {};
            item.batchInsuredExt = item.batchInsuredExt ? item.batchInsuredExt : {};
            item.country = item.nationality.split('-')[1];

            // 判断是否主被保人
            item.batchInsuredExt.isMain = item.name === mainName ? 'Y' : 'N';
            item.batchInsuredExt.mainName = mainName;
          });
          // 保单数据赋值
          this.policyForm = Object.assign(this.policyForm, content);
          this.policyForm.policy.effectiveDate = moment(content.policy.effectiveDate, 'YYYY-MM-DD');
          this.policyForm.policy.expireDate = moment(content.policy.expireDate, 'YYYY-MM-DD');
          this.policyForm.policy.productName = content.productName;
          this.policyForm.batchHolder.policyNo = content.policy.policyNo;
          this.policyForm.batchHolder.totalPremium = content.totalPremium;
          this.policyForm.plan.productName = content.productName;
          let changeContentStr = '';
          (content.changeHisList || []).forEach(item => {
            changeContentStr += `${item.content}</br> `;
          });
          this.policyForm.changeContent = changeContentStr;
          this.policyForm.remark = content.remark || '';
          document.title = content.policy.productName ? content.policy.productName : '';
        })
        .finally(() => {
          this.toggleLoading(false);
          setTimeout(() => {
            // 原始保单数据赋值
            this.originPolicyForm = this.$lodash.cloneDeep(this.policyForm);
          }, 1000);
        });
    },
    // 触发上传附件
    uploadFile(data) {
      this.policyForm.filelist = data;
    },
    // 提交成功后，弹窗确定事件
    modalOk() {
      commonMethods.closeWindow(this);
    },
    // 切换全局loading
    toggleLoading(flag) {
      this.$store.commit('setLoading', {
        show: flag
      });
    }
  }
};
